const getters = {
  token: state => state.user.token,
  email: state => state.user.avatar,
  username: state => state.user.name,
}
export default getters
